<template>
  <v-card class="mx-auto" max-width="432">
    <v-form ref="form" v-model="valid" v-if="!isLoggedIn" class="login" @submit.prevent="login">
      <v-card-title class="title font-weight-regular justify-space-between">
        <v-img src="/api/config/Client/getLogo?clientId=0" contain height="32"></v-img>
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="email"
          label="E-mail"
          data-vv-name="email"
          required
          :rules="emailRules"
          autofocus
        ></v-text-field>
        <v-text-field
          v-model="password"
          :type="'password'"
          label="Password"
          data-vv-name="password"
          required
          :rules="[v => !!v || 'Password is required']"
        ></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn :class="{blue: !valid, success: valid}" type="submit">login</v-btn>
        <v-btn type="reset">clear</v-btn>
      </v-card-actions>
    </v-form>
    <h2 v-else></h2>
    <v-alert :value="authStatus == 'error'" type="error"> Invalid username or password.</v-alert>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  mounted() {
    if (this.isLoggedIn) {
      this.$router.push('/')
    }
  },
  data() {
    return {
      email: null,
      password: null,
      valid: false,
      keepLogged: true,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  computed: {
    ...mapGetters({isLoggedIn: 'authentication/isLoggedIn'}),
    ...mapGetters({authStatus: 'authentication/authStatus'}),
  },
  methods: {
    login() {
      if (!this.$refs.form.validate()) return

      const {email: username, password, keepLogged} = this

      this.$store.dispatch('authentication/login', {username, password, keepLogged}).then(() => {
        const {returnUrl} = this.$route.query
        if (returnUrl) {
          this.$router.replace(returnUrl)
        } else {
          this.$router.replace('/')
        }
      })
    },
  },
}
</script>
